import Cookies from "js-cookie";
import TIM from "@tencentcloud/chat";
import { useEffect } from "react";

interface HeaderProps {
  tim: any;
  user: any;
  setUser: React.Dispatch<React.SetStateAction<any>>;
  setShowLoginModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const Header = ({ tim, user, setUser, setShowLoginModal }: HeaderProps) => {
  return (
    <header className="bg-[#F3F3F3] border-b border-gray-200">
      <div className="flex justify-between items-center px-2 sm:px-6 py-2">
        <div className="flex items-center space-x-2">
          <img
            src={`${process.env.PUBLIC_URL}/img/logo.png`}
            alt="J88 Logo"
            className="h-8 sm:h-10"
          />
        </div>
        <div className="hidden lg:flex">
          <nav className="flex space-x-6 text-sm text-gray-700">
            <a className="text-red-600 border-b-2 border-red-600" href="">
              Trang chủ
            </a>
            <a href="https://cpqtr.ink/" target="_blank">
              Live
            </a>
            <a href="https://cpqtr.ink/" target="_blank">
              Liveshow
            </a>
            <a href="https://cpqtr.ink/" target="_blank">
              Game+
            </a>
            <a href="https://j88x5y.vip/" target="_blank">
              Tải App
            </a>
          </nav>
        </div>
        <div className="flex flex-row space-x-2 text-xs sm:text-sm">
          {user?.account ? (
            <>
              <span className="text-red-600 px-4 text-base font-bold ">
                {user?.account}
              </span>
              <button
                onClick={() => {
                  tim
                    .logout()
                    .then(function (imResponse: any) {
                      // console.log(imResponse.data);
                    })
                    .catch(function (imError: any) {
                      // console.warn("logout error:", imError);
                    });
                  Cookies.remove("user");
                  setUser(null);
                }}
                className="bg-red-600 text-white text-center px-4 py-1 rounded-lg lg:min-w-32 cursor-pointer"
              >
                Đăng xuất
              </button>
            </>
          ) : (
            <>
              <a
                href="https://cpqtr.ink/Register"
                target="_blank"
                className="bg-red-600 text-white text-center px-4 py-1 rounded-lg lg:min-w-32 cursor-pointer"
              >
                Đăng ký
              </a>
              <button
                onClick={() => {
                  setShowLoginModal(true);
                }}
                className="border border-red-600 text-red-600 px-4 py-1 rounded-lg lg:min-w-32"
              >
                Đăng nhập
              </button>
            </>
          )}
        </div>
      </div>
      <div className="hidden lg:flex bg-red-600 text-white text-xs justify-center items-center px-6 shadow-[0_4px_8px_0_rgba(0,0,15,0.5)]">
        <div className="flex items-center pr-4 py-2 shadow-[4px_0_8px_0_rgba(0,0,15,0.2)]">
          <img
            src={`${process.env.PUBLIC_URL}/icon/bull-horn.png`}
            className="w-5 h-5 mr-2"
          />
          <span className="font-semibold">TIN TỨC MỚI NHẤT</span>
        </div>
        <div className="flex space-x-8 pl-4 overflow-hidden whitespace-nowrap">
          <div className="inline-block animate-marquee">
            <span>
              Quý hội viên vui lòng chỉ truy cập các link chính thức : 🌐
              J882.CC – J882.VIP để đăng nhập & tham gia giải trí . J88.COM – An
              tâm trải nghiệm , bảo mật tuyệt đối !
            </span>
            {/* <span>👉Link truy cập tốc độ cao : J881.LOVE - J88.REST</span>
            <span>👑 PHÁT THƯỞNG 1000 TỶ NGÀY 08 HÀNG THÁNG</span>
            <span>💎Thành viên đăng ký MỚI nhận 8</span> */}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
